"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationBank = void 0;
const OrganizationModel_1 = require("../models/OrganizationModel");
const AbstractPaginatedBank_1 = require("./base/AbstractPaginatedBank");
class OrganizationBank extends AbstractPaginatedBank_1.AbstractPaginatedBank {
    constructor(options) {
        super(options);
    }
    org(id) {
        return this.models[id];
    }
    generate(data) {
        return new OrganizationModel_1.OrganizationModel({
            clients: this.options.clients,
            banks: this.options.banks(),
            model: data
        });
    }
    patch(event) {
        event.object.options.model = event.data;
    }
    fetchPaginated(event) {
        return this.options.clients.provisionAccountsV5Client().listOrgs.paginate({
            id: event.items
        });
    }
    transform(payload) {
        return payload.objects;
    }
}
exports.OrganizationBank = OrganizationBank;
